import React, { Fragment, useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import EnquiryListPanel from "./EnquiryListPanel";

function ConfirmedEnquiries({ keyword, searchDate }) {
  const { reservationLoading, upcomingEnquiries } = useContext(AppContext);
  const [displayList, setDisplayList] = useState(null);

  useEffect(() => {
    if (!upcomingEnquiries) return;
    setDisplayList(upcomingEnquiries);
  }, [upcomingEnquiries]);

  useEffect(() => {
    filterData(searchDate, keyword);
  }, [keyword, searchDate, upcomingEnquiries]);

  const filterData = (date, keyword) => {
    if (!upcomingEnquiries || !Array.isArray(upcomingEnquiries)) return;

    let filteredData = upcomingEnquiries;

    const now = new Date();

    filteredData = filteredData.filter((data) => {
      const bookingDate = new Date(data.bookingTime);
      return bookingDate >= now;
    });

    if (date) {
      const today = new Date(date);
      filteredData = filteredData.filter((data) => {
        const bookingDate = new Date(data.bookingTime);
        return (
          bookingDate.getFullYear() === today.getFullYear() &&
          bookingDate.getMonth() === today.getMonth() &&
          bookingDate.getDate() === today.getDate()
        );
      });
    }

    if (keyword && keyword.length !== 0) {
      filteredData = filteredData.filter(
        (item) =>
          item.name.toLowerCase().includes(keyword.toLowerCase()) ||
          item.email.toLowerCase().includes(keyword.toLowerCase()) ||
          item.formattedID.toLowerCase().includes(keyword.toLowerCase()) ||
          item.phone.includes(keyword)
      );
    }

    filteredData = filteredData.filter((data) => data?.status === "Approved");

    setDisplayList(filteredData);
  };

  return (
    <Fragment>
      <EnquiryListPanel
        title="Approved reservations"
        items={displayList}
        loading={reservationLoading}
        emptyMessage="No Confirmed Enquiries"
        showStatus
      />
    </Fragment>
  );
}

export default ConfirmedEnquiries;
